import { Navigate, Route, Routes } from 'react-router-dom'
import DocumentProcessingTestPage from './DocumentProcessingTestPage'

export default function DocumentProcessingTestRoutes() {
    return (
        <Routes>
            <Route index element={<DocumentProcessingTestPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
